import React, { useState, useEffect } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import driverApi from "Services/Driver";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PreviewDriverDetails = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { openDialog, handleClose, driverId, setCloseAllTabs } = props;

  const [data, setData] = useState([]);
  const [driverDocumentsData, setDriverDocumentsData] = useState([]);
  const [documentsRow, setDocumentsRow] = useState([]);
  const [documentsInitialData, setDocumentsInitialData] = useState([]);

  const handleCloseTabs = () => {
    dispatch(
      showSnackbar({
        message: "Driver Updated Successfully",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      })
    );
    handleClose();
    setCloseAllTabs(true);
  };

  const getDriverCompleteDetails = () => {
    if (!driverId) return;
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setData(res?.data?.data);
        setDriverDocumentsData(res?.data?.data?.driverDocumentsDetails || []);
        setDocumentsInitialData([
          {
            id: 1,
            documentId: 0,
            sno: "1",
            documentType: "RSA ID OR Foreign Passport",
            documentTypeAlias: "RSA ID OR FOREIGN PASSPORT",
            file: "",
            status: "No document found",
          },
          {
            id: 2,
            sno: "2",
            documentId: 0,
            documentType: "PrDP",
            documentTypeAlias: "PRDP",
            file: "",
            status: "No document found",
          },
          {
            id: 3,
            sno: "3",
            documentId: 0,
            documentType: "Proof of address",
            documentTypeAlias: "PROOF OF ADDRESS",
            file: "",
            status: "No document found",
          },
          {
            id: 4,
            sno: "4",
            documentId: 0,
            documentType: "Proof of banking",
            documentTypeAlias: "PROOF OF BANKING",
            file: "",
            status: "No document found",
          },
          {
            id: 5,
            sno: "5",
            documentId: 0,
            documentType: "Proof of insurance",
            documentTypeAlias: "PROOF OF INSURANCE",
            file: "",
            status: "No document found",
          },
        ]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Failed to fetch driver details",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    driverApi.getDriverCompleteDetailsByDId(driverId).then(onSuccess, onFailure);
  };

  useEffect(() => {
    if (openDialog) {
      setData([]);
      setDriverDocumentsData([]);
      getDriverCompleteDetails();
    }
  }, [openDialog]);

  useEffect(() => {
    if (documentsInitialData.length > 0) {
      const combinedArray = documentsInitialData.map((item1) => {
        const matchingDocument = driverDocumentsData.find((item2) => {
          return item1.documentTypeAlias === item2?.documentType;
        });

        const documentId = matchingDocument && matchingDocument.documentPath !== "" ? "Uploaded" : "Not uploaded";
        const documentPath = matchingDocument ? matchingDocument.documentPath : "-";
        const status = matchingDocument ? (matchingDocument.documentPath ? matchingDocument.status : "NO DOCUMENT") : "NO DOCUMENT";
        const uploadedDocumentName = matchingDocument ? matchingDocument?.uploadedDocumentName : "-";

        return {
          ...item1,
          documentId,
          file: documentPath,
          status,
          uploadedDocumentName,
        };
      });

      setDocumentsRow(combinedArray);
    }
  }, [driverDocumentsData, documentsInitialData]);

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      maxWidth={false}
      className={classes.root}
    >
      <DialogTitle>
        <section className={classes.dialogTitleContainer}>
          <Typography className={classes.title}>Confirm Driver Details</Typography>
          <IconButton onClick={handleClose} size="small" sx={{ color: "#fff" }}>
            <CloseIcon />
          </IconButton>
        </section>
      </DialogTitle>
      <DialogContent>
        <Box className={classes.driverContainer}>
          {/* Header Info */}
          <Box className={classes.driverHeader}>
            <img
              src={data?.driverInfoDetails?.image || "/assets/images/user/avatar.png"}
              alt="Profile"
              className={classes.profileImage}
            />
            <Box className={classes.headerInfo}>
              <Typography className={classes.driverNameText}>
                {data?.driverInfoDetails?.firstName} {data?.driverInfoDetails?.lastName}
              </Typography>
              <Typography className={classes.driverRoleText}>Driver Profile Summary</Typography>
            </Box>
          </Box>

          {/* Basic Information */}
          <Box className={classes.detailsSection}>
            <Typography className={classes.sectionHeader}>Basic Information</Typography>
            <Box className={classes.gridContainer}>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Username</span>
                <span className={classes.value}>{data?.driverInfoDetails?.userName || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Country Code</span>
                <span className={classes.value}>{data?.driverInfoDetails?.countryCode || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Mobile Number</span>
                <span className={classes.value}>{data?.driverInfoDetails?.mobileNumber || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Email Address</span>
                <span className={classes.value}>{data?.driverInfoDetails?.email || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Gender</span>
                <span className={classes.value}>{data?.driverInfoDetails?.gender || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Country</span>
                <span className={classes.value}>{data?.driverInfoDetails?.country || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Address</span>
                <span className={classes.value}>{data?.driverInfoDetails?.address || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Bank Account Number</span>
                <span className={classes.value}>{data?.driverInfoDetails?.bankAccountNumber || "-"}</span>
              </Box>
            </Box>
          </Box>

          {/* Service Details */}
          <Box className={classes.detailsSection}>
            <Typography className={classes.sectionHeader}>Service Details</Typography>
            <Box className={classes.gridContainer}>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Service</span>
                <span className={classes.value}>{data?.driverServiceDetails?.serviceTypeId?.serviceName || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Service Type</span>
                <span className={classes.value}>{data?.driverServiceDetails?.serviceKind || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Vehicle Number</span>
                <span className={classes.value}>{data?.driverServiceDetails?.vehicleNumber || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Vehicle Model</span>
                <span className={classes.value}>{data?.driverServiceDetails?.vehicleModel || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Driver License Number</span>
                <span className={classes.value}>{data?.driverServiceDetails?.driverLicenseNumber || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>License Expiry Date</span>
                <span className={classes.value}>{data?.driverServiceDetails?.licenseExpiryDate || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Vehicle Insurance Number</span>
                <span className={classes.value}>{data?.driverServiceDetails?.vehicleInsuranceNumber || "-"}</span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Insurance Expiry Date</span>
                <span className={classes.value}>{data?.driverServiceDetails?.insuranceExpiryDate || "-"}</span>
              </Box>
            </Box>
          </Box>

          {/* Driver Documents Table */}
          <Box className={classes.detailsSection}>
            <Typography className={classes.sectionHeader}>Driver Documents</Typography>
            <table className={classes.table}>
              <thead className={classes.tableHeader}>
                <tr>
                  <th className={classes.tableHeaderCell}>Document Type</th>
                  <th className={classes.tableHeaderCell}>Status</th>
                  <th className={classes.tableHeaderCell}>Approval Status</th>
                </tr>
              </thead>
              <tbody>
                {documentsRow.map((document, index) => (
                  <tr key={index} className={classes.tableRow}>
                    <td className={classes.tableCell}>{document?.documentType}</td>
                    <td className={classes.tableCell}>{document?.documentId}</td>
                    <td className={classes.tableCell}>{document?.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>

          {/* Account Status */}
          <Box className={classes.detailsSection}>
            <Typography className={classes.sectionHeader}>Account Status</Typography>
            <Box className={classes.gridContainer}>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Account Status</span>
                <span className={classes.value}>
                  {data?.driverServiceDetails?.accountStatus === "ONBOARDING"
                    ? "Onboarding"
                    : data?.driverServiceDetails?.accountStatus === "APPROVED"
                    ? "Approved"
                    : data?.driverServiceDetails?.accountStatus === "BANNED"
                    ? "Banned"
                    : "-"}
                </span>
              </Box>
              <Box className={classes.keyValue}>
                <span className={classes.key}>Driver Status</span>
                <span className={classes.value}>
                  {data?.driverServiceDetails?.driverAccountStatus === "ACTIVE"
                    ? "Active"
                    : data?.driverServiceDetails?.driverAccountStatus === "DE_ACTIVE"
                    ? "Deactive"
                    : "-"}
                </span>
              </Box>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Box className={classes.dialogActions}>
          <Box className={classes.closeBtn}>
            <Button onClick={handleClose}>Back to Edit</Button>
          </Box>
          <Box className={classes.confirmBtn}>
            <Button onClick={handleCloseTabs}>Confirm & Close</Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewDriverDetails;
